import React, { useEffect, useState } from "react";
import HomeProduct from "./HomeProduct";
import { fetchFeaturedPets } from "../../../service/petService";
import { Link } from "react-router-dom";

const SkeletonCard = () => (
  <div className="animate-pulse bg-white rounded-2xl overflow-hidden shadow-sm">
    <div className="h-56 bg-gray-200" />
    <div className="p-5 space-y-3">
      <div className="h-4 bg-gray-200 rounded w-3/4" />
      <div className="h-3 bg-gray-200 rounded w-full" />
      <div className="h-3 bg-gray-200 rounded w-5/6" />
      <div className="h-9 bg-gray-200 rounded-full mt-4" />
    </div>
  </div>
);

const HomeProducts = () => {
  const [fixedProducts, setFixedProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchFeaturedPets()
      .then((result) => {
        setFixedProducts(result.products);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Failed to fetch featured pets:", err);
        setLoading(false);
      });
  }, []);

  return (
    <section className="max-w-7xl mx-auto py-20 px-6">
      {/* Section Heading */}
      <div className="text-center mb-14">
        <p className="text-amber-500 font-semibold text-sm uppercase tracking-widest mb-2">
          Our Collection
        </p>
        <h2 className="text-4xl font-bold text-slate-900">Explore Our Pets</h2>
        <p className="text-slate-500 mt-3 text-base max-w-xl mx-auto">
          Browse our handpicked selection of healthy, happy pets ready to find
          their forever homes.
        </p>
      </div>

      {/* Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-7">
        {loading
          ? Array.from({ length: 6 }).map((_, i) => <SkeletonCard key={i} />)
          : fixedProducts.map((product) => (
              <HomeProduct key={product._id} product={product} />
            ))}
      </div>

      {/* View All Link */}
      {!loading && (
        <div className="text-center mt-12">
          <Link
            to="/explore"
            className="inline-flex items-center gap-2 px-8 py-3 bg-slate-900 text-white rounded-full font-semibold hover:bg-amber-500 hover:text-slate-900 transition-all duration-300"
          >
            View All Pets →
          </Link>
        </div>
      )}
    </section>
  );
};

export default HomeProducts;
